import { z } from "zod";
import { EBankAccountType } from "../../bank-accounts/EBankAccountType";

export const bankAccountType = () => z.nativeEnum(EBankAccountType);
